import { z } from 'zod'

const base = z.object({
  id: z.number().optional().or(z.null()),
  teamId: z.number().optional().or(z.null()),
  userId: z.number().optional().or(z.null()),
  teamRankId: z.number().optional().or(z.null()),
  section: z.string(),
  accessLevel: z.string(),
  _destroy: z.boolean().optional(),
})

const withGameRank = base.extend({
  restrictionType: z.literal('game_rank'),
  gameRankThreshold: z.string(),
})

const withTeamRank = base.extend({
  restrictionType: z.literal('team_rank'),
  teamRankId: z.number().or(z.null()),
})

const withUser = base.extend({
  restrictionType: z.literal('user'),
  userId: z.number().optional().or(z.null()),
  battletag: z.string().optional().or(z.null()),
})

const withAnyone = base.extend({
  restrictionType: z.literal('anyone'),
})

const withLoggedIn = base.extend({
  restrictionType: z.literal('logged_in'),
})

export const accessRestrictionSchema = z.discriminatedUnion('restrictionType', [
  withGameRank,
  withTeamRank,
  withUser,
  withAnyone,
  withLoggedIn,
])

export const validateAccessRestrictions = (
  value: {
    access_restrictions_attributes: z.infer<typeof accessRestrictionSchema>[]
  },
  ctx: z.RefinementCtx,
) => {
  value.access_restrictions_attributes.forEach((restriction, index) => {
    if (restriction.restrictionType !== 'user') return
    if (restriction._destroy) return
    if (restriction.userId || restriction.battletag?.trim()) return

    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Select a user or enter a battletag',
      path: ['access_restrictions_attributes', index, 'userId'],
    })
  })
}

export type EditableAccessRestriction = wowaudit.AccessRestriction & {
  _destroy?: boolean
}
